export default "__VITE_ASSET__BWok0nVB__"